module.exports={
	"Form": "CertificationTypeViewManifest",
	"Scope": "CertificationType-View",
	"Descriptors":
	{
		"CertificationTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "CertificationType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "CertificationType-View-Identity",
				"Group": "CertificationType-View-Identity"
			}
		},
		"CertificationTypeDetails.Hash":
		{
			"Name": "Hash",
			"Hash": "CertificationType-View-Hash",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-View-Details",
				"Group": "CertificationType-View-Details"
			}
		},
		"CertificationTypeDetails.Verb":
		{
			"Name": "Verb",
			"Hash": "CertificationType-View-Verb",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "CertificationType-View-Details",
				"Group": "CertificationType-View-Details"
			}
		},
		"CertificationTypeDetails.Description":
		{
			"Name": "Description",
			"Hash": "CertificationType-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 12,
				"Section": "CertificationType-View-Details",
				"Group": "CertificationType-View-Details"
			}
		},
		"CertificationTypeDetails.IDCertificationType":
		{
			"Name": "IDCertification Type",
			"Hash": "CertificationType-View-IDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.GUIDCertificationType":
		{
			"Name": "GUIDCertification Type",
			"Hash": "CertificationType-View-GUIDCertificationType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "CertificationType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "CertificationType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "CertificationType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		},
		"CertificationTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "CertificationType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "CertificationType-View-DataAudit",
				"Group": "CertificationType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "CertificationType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "CertificationType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "CertificationType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "CertificationType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "CertificationType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "CertificationType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
